export enum ERentalsPerm {
    RENTALS_DELETE = 'rentals_delete',
    RENTALS_EDIT = 'rentals_edit',
    RENTALS_VIEW = 'rentals_view'
}
